import { defineSlotRecipe } from '@chakra-ui/react';
import { progressAnatomy } from '@chakra-ui/react/anatomy';

import { progressRangeMinWidth, progressTrackHeight } from './progress-bar.kds';

const kdsTrackStyles = {
  shadow: 'none',
  bg: 'neutral.50',
  borderWidth: '1px',
  borderColor: 'neutral.100',
  borderRadius: 'full',
  h: progressTrackHeight,
} as const;

const kdsRangeStyles = {
  bg: 'brand.500',
  bgColor: 'brand.500',
  borderRadius: 'full',
  minW: progressRangeMinWidth,
  _indeterminate: {
    bg: 'brand.500',
    bgColor: 'brand.500',
  },
} as const;

/** KDS Progress Bar — overrides Chakra `progress` slot recipe (node 1062:11557). */
export const progressBarSlotRecipe = defineSlotRecipe({
  slots: progressAnatomy.keys(),
  variants: {
    variant: {
      outline: {
        track: kdsTrackStyles,
        range: kdsRangeStyles,
      },
    },
    shape: {
      full: {},
    },
    size: {
      md: {
        track: { h: progressTrackHeight },
      },
    },
  },
  defaultVariants: {
    variant: 'outline',
    shape: 'full',
    size: 'md',
  },
});
